import { reactive, watch } from 'vue';

// Initialize with a default value or from localStorage
const storedIsIndianUser = localStorage.getItem('isIndianUser');
const initialIsIndianUser = storedIsIndianUser !== null ? JSON.parse(storedIsIndianUser) : true;

export const currencyStore = reactive({
    isIndianUser: initialIsIndianUser,
    countryDetected: false,
    
    toggleCurrency() {
        this.isIndianUser = !this.isIndianUser;
        localStorage.setItem('isIndianUser', JSON.stringify(this.isIndianUser));
    },
    
    setCurrency(isIndian) {
        this.isIndianUser = isIndian;
        localStorage.setItem('isIndianUser', JSON.stringify(this.isIndianUser));
    },

    async detectUserCountry() {
        // If we already have a user-defined preference in localStorage, maybe don't override?
        // Or only override if it's the first time.
        if (localStorage.getItem('isIndianUser') !== null) {
            this.countryDetected = true;
            return;
        }

        try {
            const response = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
            if (response.ok) {
                const geo = await response.json();
                this.isIndianUser = geo?.country_code === 'IN';
                localStorage.setItem('isIndianUser', JSON.stringify(this.isIndianUser));
            }
        } catch (e) {
            console.warn('Country detection failed, defaulting to INR pricing:', e);
        } finally {
            this.countryDetected = true;
        }
    }
});
